<template>
  <div class="container-fluid">
    <div class="row">
      <div class="col-lg-2">
        <div class="card">
          <div class="card-body dropzone-kundenbild-admin">
            <div class="headline_under">
              <div class="v-super">Kundenbild</div>
            </div>
            <img class="bplogo_preview" v-if="!showKbDZ" :src="kundenbildURL.url" @click="showKbDZ = true">
            <vue-dropzone
              ref="kundenbild_dropzone"
              :options="kundenbild_dropzone_options"
              id="kundenbild_dropzone"
              v-on:vdropzone-file-added="refreshDropzoneAuth"
              v-on:vdropzone-success="processAsset"
              v-if="showKbDZ"
            ></vue-dropzone>
              <div class="last_login">Letzter Login: {{last_login}}</div>         
          </div>
        </div>
      </div>
      <div class="col-lg-3">
        <div class="card">
          <div class="card-body">
            <div class="headline_under">
              <div class="v-super" @click="debug">Kundendaten</div>
            </div>
            <div class="form-container">
              <label>Vorname*</label>
              <b-input-group class="form-input-group" prepend="Abc">
                <b-form-input
                  class="form-control"
                  name="first_name"
                  v-model="first_name"
                  @blur="validate"
                  v-bind:class="{ form_error: hasError('first_name') }"
                ></b-form-input>
                <feather
                  type="check"
                  v-if="!hasError('first_name') && !updating.first_name && first_name.length"
                  name="first_name"
                  class="checkmark"
                ></feather>
                <feather type="x" v-if="hasError('first_name') && !updating.first_name" name="first_name" class="failmark"></feather>
                <Loader size="20" v-if="updating.first_name" class="loader" />
              </b-input-group>
              <label>Nachname*</label>
              <b-input-group class="form-input-group" prepend="Abc">
                <b-form-input
                  class="form-control"
                  name="last_name"
                  v-model="last_name"
                  @blur="validate"
                  v-bind:class="{ form_error: hasError('last_name') }"
                ></b-form-input>
                <feather
                  type="check"
                  v-if="!hasError('last_name') && !updating.last_name && last_name.length"
                  name="last_name"
                  class="checkmark"
                ></feather>
                <feather type="x" v-if="hasError('last_name') && !updating.last_name" name="last_name" class="failmark"></feather>
                <Loader size="20" v-if="updating.last_name" class="loader" />
              </b-input-group>
              <label>Telefon</label>
              <b-input-group class="form-input-group" prepend="123">
                <b-form-input
                  class="form-control"
                  name="telefon"
                  v-model="telefon"
                  @blur="validate"
                  v-bind:class="{ form_error: hasError('telefon') }"
                ></b-form-input>
                <feather type="check" v-if="!hasError('telefon') && !updating.telefon && telefon.length" name="telefon" class="checkmark"></feather>
                <feather type="x" v-if="hasError('telefon') && !updating.telefon" name="telefon" class="failmark"></feather>
                <Loader size="20" v-if="updating.telefon" class="loader" />
              </b-input-group>
              <label>E-Mail*</label>
              <b-input-group class="form-input-group" prepend="@">
                <b-form-input
                  class="form-control"
                  name="email"
                  v-model="email"
                  @blur="validate"
                  v-bind:class="{ form_error: hasError('email') }"
                ></b-form-input>
                <feather type="check" v-if="!hasError('email') && !updating.email && email.length" name="email" class="checkmark"></feather>
                <feather type="x" v-if="hasError('email') && !updating.email" name="email" class="failmark"></feather>
                <Loader size="20" v-if="updating.email" class="loader" />
              </b-input-group>    
              <b-input-group>
                <transition
                  :name="animations.slideLtr.name"
                  :enter-active-class="animations.slideLtr.enter"
                  :leave-active-class="animations.slideLtr.leave"
                >
                  <span v-if="mailSent" style="padding-top:7px;margin-right:10px;">Mail versandt!</span>
                </transition>
                <transition
                  :name="animations.slideLtr.name"
                  :enter-active-class="animations.slideLtr.enter"
                  :leave-active-class="animations.slideLtr.leave"
                >
                  <span style="padding-top:7px;margin-right:10px;" v-if="sending">Sende...</span>
                </transition>
                <b-button size="md" @click="inviteCustomer">Passwort Mail an Kunde</b-button>
              </b-input-group>
            </div>
          </div>
        </div>
      </div>
      <div class="col-lg-3">
        <div class="card">
          <div class="card-body">
            <div class="headline_under">
              <div class="v-super">Anschrift</div>
            </div>
            <div class="form-container">
              <label>Strasse</label>
              <b-input-group class="form-input-group" prepend="Abc">
                <b-form-input class="form-control" name="strasse" v-model="strasse" @blur="validate"></b-form-input>
                <feather type="check" v-if="!hasError('strasse') && !updating.strasse && strasse.length" name="strasse" class="checkmark"></feather>
                <feather type="x" v-if="hasError('strasse') && !updating.strasse" name="strasse" class="failmark"></feather>
                <Loader size="20" v-if="updating.strasse" class="loader" />
              </b-input-group>

              <label>Ort</label>
              <b-input-group class="form-input-group" prepend="Abc">
                <b-form-input class="form-control" name="ort" v-model="ort" @blur="validate"></b-form-input>
                <feather type="check" v-if="!hasError('ort') && !updating.ort && ort.length" name="ort" class="checkmark"></feather>
                <feather type="x" v-if="hasError('ort') && !updating.ort" name="ort" class="failmark"></feather>
                <Loader size="20" v-if="updating.ort" class="loader" />
              </b-input-group>

              <label>PLZ</label>
              <b-input-group class="form-input-group" prepend="123">
                <b-form-input class="form-control" name="plz" v-model="plz" @blur="validate"></b-form-input>
                <feather type="check" v-if="!hasError('plz') && !updating.plz && plz.length" name="plz" class="checkmark"></feather>
                <feather type="x" v-if="hasError('plz') && !updating.plz" name="plz" class="failmark"></feather>
                <Loader size="20" v-if="updating.plz" class="loader" />
              </b-input-group>

              <label>Beschreibung</label>
              <b-input-group class="form-input-group">
                <textarea rows="3" class="form-control" name="beschreibung" v-model="beschreibung" @blur="validate" />
                <feather
                  type="check"
                  v-if="!hasError('beschreibung') && !updating.beschreibung && beschreibung.length"
                  name="beschreibung"
                  class="checkmark"
                ></feather>
                <feather type="x" v-if="hasError('beschreibung') && !updating.beschreibung" name="beschreibung" class="failmark"></feather>
                <Loader size="20" v-if="updating.beschreibung" class="loader" />
              </b-input-group>
            </div>
          </div>
        </div>
      </div>
      <div class="col-4">
        <div class="card">
          <div class="card-body">
            <div class="headline_under">
              <div class="v-super">Wohnungen</div>
              <div class="icon-clickable-right" @click="showModalWohnungen">
                <feather type="plus"></feather>
              </div>
            </div>
            <div class="default-table" v-if="selectedWohnungen.length > 0">
              <div class="default-table-legend">
                <div>Wohnung</div>
                <div>Haus</div>
                <div>Bauprojekt</div>
              </div>
              <div class="default-table-row" v-for="(wohnung, index) in selectedWohnungen" :key="index">
                <div>{{ wohnung.name }}</div>
                <div>{{ wohnung.haus.name }}</div>
                <div>{{ wohnung.bauprojekt.name }}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <b-modal size="lg" id="assignWohnung" @ok="updateSelectedWohnungen">
        <div class="container-fluid">
          <div class="row">
            <div class="col-10" style="margin:0 auto;">
              <div class="card-body" v-if="modalStep == 0">
                <div class="default-table">
                  <div class="default-table-legend">
                    <div>Name</div>
                    <div>Häuser</div>
                    <div>Kunde</div>
                    <div>frei</div>
                  </div>
                  <div v-for="bp in bauprojekte" :key="bp.id" class="default-table-row clickable-row" @click.prevent="selectBauprojekt(bp.id)">
                    <div>
                      {{ bp.name }}
                    </div>
                    <div>
                      <span class="badge badge-primary">{{ howManyHouses(bp.id) }}</span>
                    </div>
                    <div>
                      <span class="badge badge-secondary">{{ howManySelected(bp.id, "bauprojekt") }}</span>
                    </div>
                    <div>
                      <span class="badge badge-success">{{ howManyFree(bp.id, "bauprojekt") }}</span>
                    </div>
                  </div>
                </div>
              </div>
              <div class="card-body" v-if="modalStep == 1">
                <div class="default-table">
                  <div class="default-table-legend">
                    <div>Name</div>
                    <div>Wohnungen</div>
                    <div>Kunde</div>
                    <div>verfügbar</div>
                  </div>
                  <div
                    class="default-table-row clickable-row"
                    v-for="haus in modalSelectedBauprojekt.hauser"
                    :key="haus.id"
                    @click="selectHaus(haus.id)"
                  >
                    <div>{{ haus.name }}</div>
                    <div>
                      <span class="badge badge-primary">{{ howManyWohnungen(haus.id) }}</span>
                    </div>
                    <div>
                      <span class="badge badge-secondary">{{ howManySelected(haus.id, "haus") }}</span>
                    </div>
                    <div>
                      <span class="badge badge-success">{{ howManyFree(haus.id, "haus") }}</span>
                    </div>
                  </div>
                </div>
              </div>
              <div class="card-body" v-if="modalStep == 2">
                <div class="default-table">
                  <div class="default-table-legend">
                    <div>Auswahl</div>
                    <div>Name</div>
                    <div>Wohnflaeche</div>
                    <div>Kaufpreis</div>
                  </div>
                  <div v-for="wohnung in modalSelectedHaus.wohnungen" :key="wohnung.id" @click="selectWohnung(wohnung)" class="default-table-row clickable-row">
                    <div><input type="checkbox" :checked="isSelectedWohnung(wohnung.id)" /></div>
                    <div>{{ wohnung.name }}</div>
                    <div>{{ wohnung.wohnflaeche }} m<sup>2</sup></div>
                    <div>{{ displayCurrency(wohnung.kaufpreis) }}</div>
                  </div>
                </div>
              </div>
              <div class="card" v-if="modalStep == 2"></div>
            </div>
          </div>
        </div>
        <template v-slot:modal-header>
          <div class="container-fluid">
            <div class="row">
              <div
                class="u-pearl col-4 progress_pearl"
                :class="{ current: modalStep == 0, done: modalStep == 1 || modalStep == 2 }"
                id="stepOne"
                ref="stepOne"
              >
                <span class="u-pearl-number">1</span>
                <transition
                  :name="animations.standard.name"
                  :enter-active-class="animations.standard.enter"
                  :leave-active-class="animations.standard.leave"
                  mode="out-in"
                >
                  <span v-if="!modalSelectedBauprojekt.name" class="u-pearl-title" key="bpchoose">Bauprojekt wählen</span>
                  <span v-if="modalSelectedBauprojekt.name" class="u-pearl-title" key="bpchosen">Bauprojekt: {{ modalSelectedBauprojekt.name }}</span>
                </transition>
              </div>
              <div class="u-pearl col-4 progress_pearl" :class="{ current: modalStep == 1, done: modalStep == 2 }" id="stepTwo" ref="stepTwo">
                <span class="u-pearl-number">2</span>
                <transition
                  :name="animations.standard.name"
                  :enter-active-class="animations.standard.enter"
                  :leave-active-class="animations.standard.leave"
                  mode="out-in"
                >
                  <span v-if="!modalSelectedHaus.name" class="u-pearl-title" key="hauschoose">Haus wählen</span>
                  <span v-if="modalSelectedHaus.name" class="u-pearl-title" key="hauschosen">Haus: {{ modalSelectedHaus.name }}</span>
                </transition>
              </div>
              <div class="u-pearl col-4 progress_pearl" :class="{ current: modalStep == 2 }" id="stepThree" ref="stepThree">
                <span class="u-pearl-number">3</span>
                <span class="u-pearl-title">Wohnung wählen</span>
              </div>
            </div>
          </div>
          <feather type="x" class="pointer" @click="resetModalState"></feather>
        </template>
        <template v-slot:modal-footer>
          <transition
            :name="animations.standard.name"
            :enter-active-class="animations.standard.enter"
            :leave-active-class="animations.standard.leave"
          >
            <b-button v-if="modalStep > 0" @click="stepBack(modalStep)">Zurück</b-button>
          </transition>
          <b-button @click="resetModalState">Abbrechen</b-button>
          <b-button @click="updateSelectedWohnungen">Speichern</b-button>
        </template>
      </b-modal>
    </div>
    <div class="row">
      <div class="col-12">
        <Media />
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import vue2Dropzone from "vue2-dropzone";
import Loader from "@/components/loader.vue";
import Media from "@/components/Media.vue";
import axios from "axios";

export default {
  name: "AdminEditKunde",
  data() {
    return {      
      showKbDZ: false,
      sending: false,
      kunde_id: false,
      first_name: "",
      last_name: "",
      telefon: "",
      email: "",
      strasse: "",
      ort: "",
      plz: "",
      beschreibung: "",
      last_login: "",
      user: false,
      kundenbild: false,
      kundenbildURL: "",
      mailSent: false,
      validation_errors: [],
      validation_success: [],
      dzThumbSize: 200,
      modalStep: 0,
      kunde_wohnungen_rel: [],
      modalSelectedBauprojekt: {
        name: false,
        id: false,
        index: false,
        hauser: false,
      },
      modalSelectedHaus: {
        name: false,
        id: false,
        index: false,
        wohnungen: false,
      },
      modalSelectedWohnungen: [],
      selectedWohnungen: [],
      defaultBauprojekt: {
        name: false,
        id: false,
        index: false,
        hauser: false,
      },
      defaultHaus: {
        name: false,
        id: false,
        index: false,
        wohnungen: false,
      },
      updating: {
        first_name: false,
        last_name: false,
        telefon: false,
        email: false,
        strasse: false,
        ort: false,
        plz: false,
        beschreibung: false,
      },
    };
  },
  components: {
    vueDropzone: vue2Dropzone,
    Loader: Loader,
    Media,
  },
  computed: {
    ...mapGetters({
      bauprojekte: "app/bauprojekte",
      api: "auth/apiSettings",
      toast: "app/toasts",
      hauser: "app/hauser",
      wohnungen: "app/wohnungen",
      animations: "app/animations",
      kunden: "app/kunden",
      devMode: "app/devMode",
      devMail: "app/devMail",
      token: "auth/apiToken",
      mailerURL: "app/mailerURL"
    }),
  },
  created: async function() {
    this.getKundenData();

    //kundenbild dropzone
    this.kundenbild_dropzone_options = {
      url: this.api.customUploads,
      thumbnailMethod: "contain",
      thumbnailWidth: this.dzThumbSize,
      maxFiles: 1,
      clickable: ".dropzone-kundenbild-admin",
      init: function() {
        this.on("maxfilesexceeded", function(file) {
          this.removeAllFiles();
          this.addFile(file);
        });
      },
      dictDefaultMessage:
        '<svg xmlns="http://www.w3.org/2000/svg" width="50" height="50" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-upload-cloud"><polyline points="16 16 12 12 8 16"></polyline><line x1="12" y1="12" x2="12" y2="21"></line><path d="M20.39 18.39A5 5 0 0 0 18 9h-1.26A8 8 0 1 0 3 16.3"></path><polyline points="16 16 12 12 8 16"></polyline></svg>',

      headers: {
        Authorization: "",
        "Cache-Control": null,
        "X-Requested-With": null,
      },
    };

    if(this.kundenbild) {
      const getKundenbildURL = await this.$store.dispatch("images/getImgURL", {
        id: this.kundenbild,
        mode: "imgtag",
        format: "thumb-200-full",
        volatile: true
      });
      this.kundenbildURL = getKundenbildURL;
      this.showKB = true;
    } else {
      this.showKbDZ = true;
    }
        
  },
  methods: {
    async refreshDropzoneAuth() {           
      await this.$store.dispatch("auth/refreshToken");
      this.kundenbild_dropzone_options.headers.Authorization = "bearer " + this.token;
    }, 
    async sendPwMail() {
      if (this.email.length) {
        try {
          await this.$store.dispatch("auth/reqPwReset", this.email);
          this.mailSent = true;
          setTimeout(() => {
            this.mailSent = false;
          }, 4000);
        } catch (error) {
          console.log(error);
          this.$toasted.show(error, this.toasts.failure);
        }
      }
    },
    async sendResetMail() {
      const token =  await this.$directus.auth.token;
      const url = "https://" + process.env.VUE_APP_API_HOST + "/public/" + process.env.VUE_APP_API_PROJECT + "/mail";
      const options = {
        headers: {
          Authorization: "bearer " + token,
        },
      };

      const targetMail = this.devMode ? [this.devMail] : [this.email];
      const data = {
        to: targetMail,
        from: "no-reply@infrabau-portal.de",
        subject: "Infrabau Kundenportal Zugang",
        body: `
        Sehr geehrte Damen und Herren, <br/>
        <br /><br />
        <span style='margin-top:20px; margin-bottom:20px;'>da leider immer noch Probleme bei
        der Anmeldung in unserem Kundenportal auftreten, haben wir an einer Lösung gearbeitet. <br /><br />
        Falls es Ihnen schon gelungen ist sich anzumelden, ist diese Mail für Sie hinfällig.
        Sollte es Ihnen noch nicht möglich gewesen sein sich anzumelden, gehen Sie bitte auf den folgenden Button. </span>
        <br /><br />
        <a href='https://infrabau-portal.de/forgotPassword'>Passwort einrichten</a>
        <br /><br />
        <span style='margin-top:20px; margin-bottom:20px;'>Ihr Infrabau Team</span>
        `,
        type: "html",
        data: {
          vorname: this.first_name,
          nachname: this.last_name,
        },
      };

      try {
        await axios.post(url, data, options);
        this.sending = false;
        this.mailSent = true;
        setTimeout(() => {
          this.mailSent = false;
        }, 4000);
      } catch (error) {
        this.$toasted.show(error, this.toasts.failure);
      }
    },

    async inviteCustomer() {
      const newPassword = await this.$store.dispatch("auth/genPW");
      const kunde = await this.$directus.items("kunde").readOne(this.kunde_id, { fields: ["user.*"] });
      console.log("setting new password");
      console.log(kunde.user);
      try {
        await this.$directus.items("directus_users").updateOne(kunde.user.id, { password: newPassword });
        await this.sendInviteMail(newPassword, kunde.user);
      } catch (err) {
        console.log(err);
        this.$toasted.show("Fehler beim Setzen des Passwort", this.toasts.failure);
      }
    },

    async sendInviteMail(password, kunde) {
      this.sending = true;
      const token =  await this.$directus.auth.token;
      const url = this.mailerURL;
      const options = {
        withCredentials:true,
        headers: {
          Authorization: "bearer " + token,
        },
      };

      const targetMail = this.devMode ? [this.devMail] : [this.email];

      const data = {
        to: targetMail,       
        subject: "Infrabau Kundenportal Zugang",
        body: `
        <span style='font-weight:bold;'>Herzlich Willkommen in unserem infrabau Kundenportal!</span> <br/>
        <br /><br />
        <span style='margin-top:20px; margin-bottom:20px;'>Mit folgenden Anmeldedaten können Sie Ihr Kundenkonto freischalten: <br /><br /></span>
        <p>Zugang zum Portal: https://infrabau-portal.de</p>
        <p>Ihr Benutzername: ${kunde.email}</p>
        <p>Ihr Passwort: ${password}</p>
        <p>Sie können jederzeit ein neues, personalisiertes Passwort unter „Mein Profil“ erstellen. </p>
        <p>Wir bedanken uns für Ihr Vertrauen und freuen uns auf die Zusammenarbeit.</p> 
        <p>Mit freundlichen Grüßen</p>
        <p>Ihr infrabau Team</p>               
        `,
        type: "html",
        data: {
          vorname: this.first_name,
          nachname: this.last_name,
          email: this.email,
          pw: password,
        },
      };

      try {
        await axios.post(url, data, options);
        console.log("============ sending post request with header ==============");
        console.log(options);
        this.sending = false;
        setTimeout(() => {
          this.mailSent = true;
        }, 2000);
      } catch (error) {
        this.$toasted.show(error, this.toasts.failure);
      }
    },
    howManySelected(id, type) {
      const selected = this.modalSelectedWohnungen.filter((wohnung) => wohnung[type].id == id);
      return selected.length;
    },

    howManyFree(id, type) {
      let free = 0;
      //get all free wohnungen for the bauprojekt
      if (type == "bauprojekt") {
        const currentBpr = this.bauprojekte.find((bpr) => id == bpr.id);
        if (currentBpr.extended.hauser.length) {
          currentBpr.extended.hauser.forEach((haus) => {
            if (haus.extended.wohnungen.length) {
              const freePerHouse = haus.extended.wohnungen.filter((wohnung) => wohnung.status == "verfügbar");
              if (freePerHouse.length) free = free + freePerHouse.length;
            }
          });
        }
      }

      if (type == "haus") {
        const currentHaus = this.modalSelectedBauprojekt.hauser.find((haus) => haus.id == id);
        if (currentHaus.extended.wohnungen.length) {
          const freePerHouse = currentHaus.extended.wohnungen.filter((wohnung) => wohnung.status == "verfügbar");
          if (freePerHouse.length) free = freePerHouse.length;
        }
      }
      return free;
    },
    howManyWohnungen(id) {
      const haus = this.hauser.find((haus) => haus.id == id);
      return haus.extended.wohnungen.length;
    },
    howManyHouses(id) {
      const bp = this.bauprojekte.find((bpr) => bpr.id == id);
      return bp.extended.hauser.length;
    },
    showModalWohnungen() {
      this.modalSelectedWohnungen = JSON.parse(JSON.stringify(this.selectedWohnungen));
      this.$bvModal.show("assignWohnung");
    },
    selectBauprojekt(bauprojekt_id) {
      const bauprojekt_index = this.bauprojekte.findIndex((bp) => bp.id == bauprojekt_id);
      this.modalSelectedBauprojekt.id = bauprojekt_id;
      this.modalSelectedBauprojekt.name = this.bauprojekte[bauprojekt_index].name;
      this.modalSelectedBauprojekt.index = bauprojekt_index;
      this.modalStep = 1;
      if ("undefined" !== typeof this.bauprojekte[bauprojekt_index].extended.hauser && this.bauprojekte[bauprojekt_index].extended.hauser.length)
        this.modalSelectedBauprojekt.hauser = this.bauprojekte[bauprojekt_index].extended.hauser;
    },
    selectHaus(id) {
      const haus_index = this.bauprojekte[this.modalSelectedBauprojekt.index].extended.hauser.findIndex((haus) => haus.id == id);
      const haus_obj = this.bauprojekte[this.modalSelectedBauprojekt.index].extended.hauser.find((haus) => haus.id == id);
      this.modalSelectedHaus.index = haus_index;
      this.modalSelectedHaus.name = haus_obj.name;
      this.modalSelectedHaus.id = haus_obj.id;
      this.modalStep = 2;
      this.modalSelectedHaus.wohnungen = [];
      //assign all wohnungen which are "verfügbar" to the possible selection
      if ("undefined" !== typeof haus_obj.extended.wohnungen && haus_obj.extended.wohnungen.length) {
        this.modalSelectedHaus.wohnungen = haus_obj.extended.wohnungen.filter(
          (wohnung) => wohnung.status == "verfügbar" || this.selectedWohnungen.find((woh) => woh.id == wohnung.id)
        );
      }
    },
    selectWohnung(wohnung) {
      const wohnung_selection = {
        name: wohnung.name,
        id: wohnung.id,
        haus: {
          name: this.modalSelectedHaus.name,
          id: this.modalSelectedHaus.id,
        },
        bauprojekt: {
          name: this.modalSelectedBauprojekt.name,
          id: this.modalSelectedBauprojekt.id,
        },
      };
      const isSelected = this.modalSelectedWohnungen.findIndex((woh) => woh.id == wohnung_selection.id);
      if (isSelected > -1) this.modalSelectedWohnungen.splice(isSelected, 1);
      if (isSelected == -1) this.modalSelectedWohnungen.push(wohnung_selection);
    },
    stepBack(step) {
      switch (step) {
        case 1:
          this.modalSelectedHaus = this.defaultHaus;
          this.modalStep = 0;
          break;
        case 2: {
          this.modalSelectedHaus = this.defaultHaus;
          this.modalStep = 1;
          break;
        }
      }
    },
    isSelectedWohnung(id) {
      return this.modalSelectedWohnungen.findIndex((wohnung) => wohnung.id == id) > -1 ? true : false;
    },
    resetModalState() {
      this.modalSelectedBauprojekt = this.defaultBauprojekt;
      this.modalSelectedHaus = this.defaultHaus;
      this.modalSelectedWohnungen = [];
      this.modalStep = 0;
      this.$bvModal.hide("assignWohnung");
    },
    updateSelectedWohnungen() {
      this.selectedWohnungen = JSON.parse(JSON.stringify(this.modalSelectedWohnungen));
      this.$bvModal.hide("assignWohnung");
      this.resetModalState();
      this.saveWohnungRelation();
    },
    async saveWohnungRelation() {
      //get all ids of the existing relation and write their id to an array
      const removeWohnungenRelation = this.kunde_wohnungen_rel.map((relation) => {
        return relation.id;
      });

      const removeWohnungen = this.kunde_wohnungen_rel.map((wohnung) => {
        return wohnung.wohnung;
      });

      const removeRequest = {
        collection: "kunde_wohnung",
        items: removeWohnungenRelation,
      };

      //remove the existing relations
      if (removeWohnungen.length) this.$store.dispatch("app/removeItems", removeRequest);

      const statusAvailablePayload = {
        collection: "wohnung",
        ids: removeWohnungen,
        change: {status: "verfügbar"} 
      };

      if (removeWohnungen.length) this.$store.dispatch("app/updateMultiple", statusAvailablePayload);

      //abort if there are no selected wohnungen
      if (!this.selectedWohnungen.length) {
        await this.$store.dispatch("app/apiGetHouses");
        await this.$store.dispatch("app/apiGetWohnungen");
        await this.getKundenData();
        return;
      }

      //prepare the payload for the relations
      const allKundeWohnungen = this.selectedWohnungen.map((woh) => {
        const result = {
          kunde: this.kunde_id,
          wohnung: woh.id,
        };
        return result;
      });

      const createKuWoRelation = {
        collection: "kunde_wohnung",
        items: allKundeWohnungen,
      };

      //prepare the payload for the status change
      const statusReservedWohnungen = this.selectedWohnungen.map((woh) => {
        const result = woh.id;
        return result;
      });

      const statusReservedPayload = {
        collection: "wohnung",
        ids: statusReservedWohnungen,
        change: {status: "reserviert"}
      };

      //create new relations for the selected wohnungen
      try {
        await this.$store.dispatch("app/createMultiple", createKuWoRelation);
        await this.$store.dispatch("app/updateMultiple", statusReservedPayload);
        await this.$store.dispatch("app/apiGetHouses");
        await this.$store.dispatch("app/apiGetWohnungen");
        await this.getKundenData();
      } catch (error) {
        this.$toasted.show("Fehler beim Speichern der zugeordneten Wohnungen", this.toast.failure);
      }
    },
    processUploadState() {
      return true;
    },
    async processAsset(response = null, data = null) {
      //handle error / success of upload
      if (!response.xhr.status == 200) {
        this.$toasted.show("Fehler beim Upload", this.toast.failure);
        return;
      }
      this.$toasted.show(data.data.filename_download + " hochgeladen", this.toast.success);
      //check what type of asset was uploaded
      const asset_type = response.previewElement.parentNode.id.split("_")[0];

      try {
        const updateKundenbild = {
          image: data.data.id,
        };

        const updateBildTag = {
          tags: [asset_type],
        };

        const updateUserImg = {
          avatar: data.data.id,
        };

        await this.$directus.files.updateOne(data.data.id, updateBildTag);
        await this.$directus.items("kunde").updateOne(this.kunde_id, updateKundenbild);
        await this.updateUser(updateUserImg);
        await this.$store.dispatch("app/apiGetKunden");
      } catch (error) {
        this.$toasted.show("Fehler beim Zuweisen des Kundenbildes", this.toast.success);
      }
      //tag the item in directus with the correct asset type

      this[asset_type] = data.data.id;
    },
    hasError(field) {
      return this.validation_errors.indexOf(field) > -1 ? true : false;
    },
    async validate(field, mode = "default") {
      let fieldName;
      if (mode == "default") fieldName = field.target.name;
      if (mode == "manual") fieldName = field.field;
      const errorExists = this.validation_errors.indexOf(fieldName);
      const validationExists = this.validation_success.indexOf(fieldName);
      if (errorExists > -1) this.validation_errors.splice(errorExists, 1);
      if (validationExists > -1) this.validation_success.splice(validationExists, 2);
      this.updating[fieldName] = true;

      const validationPayload = {
        context: "kunden",
        field: fieldName,
        value: this[fieldName],
      };

      const validation_result = await this.$store.dispatch("app/validateField", validationPayload);
      if (!validation_result) this.validation_errors.push(fieldName);
      if (validation_result) this.validation_success.push(fieldName);

      //mutate the kunde in directus and refetch the list
      let mutationPayload = {};
      mutationPayload[fieldName] = this[fieldName];

      //mutate the user of the kunde as well if its one of the required fields
      const userFields = ["first_name", "last_name", "email"];
      const needsUserUpdate = userFields.indexOf(fieldName) > -1 ? true : false;
      if (needsUserUpdate) await this.updateUser(mutationPayload);

      try {
        await this.$directus.items("kunde").updateOne(this.kunde_id, mutationPayload);
        this.updating[fieldName] = false;
        await this.$store.dispatch("app/apiGetKunden");
      } catch (error) {
        this.$toasted.show("Fehler beim Aktualisieren von " + fieldName, this.toast.failure);
        this.updating[fieldName] = false;
        this.validation_errors.push(fieldName);
      }
    },
    async updateUser(payload) {
      console.log("updateUser was called with Payload");
      console.log(payload);

      try {
        await this.$directus.users.updateOne(this.user, payload);
      } catch (error) {
        console.log(error);
        this.$toasted.show("Fehler beim Aktualisieren des Users.", this.toast.failure);
      }
    },
    async getKundenData() {
      //find current kunde
      const kunde = this.kunden.find((kunde) => kunde.id == this.$route.params.kunde_id);
      this.kunde_id = kunde.id;
      //assign data
      this.first_name = kunde.first_name;
      this.last_name = kunde.last_name;
      this.email = kunde.email;
      this.kundenbild = kunde.image ? kunde.image : false;
      this.ort = kunde.ort ? kunde.ort : "";
      this.strasse = kunde.strasse ? kunde.strasse : "";
      this.plz = kunde.plz ? kunde.plz : "";
      this.beschreibung = kunde.beschreibung ? kunde.beschreibung : "";
      this.telefon = kunde.telefon ? kunde.telefon : "";
      this.user = kunde.user;
      this.last_login = kunde.last_login;
      const filterWohnungen = {
        filter: {
          kunde: this.kunde_id,
        },
      };
      const relationData = await this.$store.dispatch("app/getRelationItems", { collection: "kunde_wohnung", filter: filterWohnungen });
      this.kunde_wohnungen_rel = relationData.data;

      if (this.kunde_wohnungen_rel.length) this.getKundeWohnungen();
    },
    getKundeWohnungen() {
      let foundWohnungen = [];
      let kundeWohnungen = [];

      this.kunde_wohnungen_rel.forEach((woh) => {
        let result = this.wohnungen.find((w) => w.id == woh.wohnung);
        if ("undefined" !== typeof result) foundWohnungen.push(result);
      });

      foundWohnungen.forEach((woh) => {
        const foundHaus = this.hauser.find((h) => h.id == woh.haus);
        const foundBp = this.bauprojekte.find((bp) => bp.id == foundHaus.haus_bp);
        const result = {
          name: woh.name,
          id: woh.id,
          haus: {
            name: foundHaus.name,
            id: foundHaus.id,
          },
          bauprojekt: {
            name: foundBp.name,
            id: foundBp.id,
          },
        };
        kundeWohnungen.push(result);
      });

      this.selectedWohnungen = kundeWohnungen;
    },
    async debug() {
      const allRoles = await this.$directus.roles;
      console.log(allRoles);
    },
  },
};
</script>

<style>

.last_login {
  margin-bottom:10px;
  font-size:0.8em;
}
#kundenbild_dropzone {
  min-height: 200px !important;
}

#kundenbild_dropzone .dz-default.dz-message span {
  max-width: 100% !important;
  text-align: center;
}

.progress_pearl {
  display: inline;
}
.select-bauprojekt-container,
.select-haus-container {
  display: flex;
  flex-flow: row;
  flex-wrap: wrap;
  margin: 0 auto;
  justify-content: space-between;
  margin-top: 20px;
}
.bauprojekt-button,
.haus-button,
.wohnung-button {
  position: relative;
  border: 1px solid grey;
  padding: 20px;
  margin-bottom: 10px;
  cursor: pointer;
  width: 32.5%;
  text-align: center;
}

.selected_bauprojekt,
.selected_haus {
  background: red;
}

.wohnung-button .selected_check {
  visibility: hidden;
  position: absolute;
  right: 20px;
}

.wohnung-button.selected .selected_check {
  visibility: visible;
}
</style>

<style scoped>
.form-group {
  position: relative;
}

.checkmark {
  color: green;
}

.failmark {
  color: red;
}

.loader {
  backdrop-filter: none;
  -webkit-backdrop-filter: none;
  -moz-backdrop-filter: none;
}
.loader,
.checkmark,
.failmark {
  position: absolute;
  bottom: 7px;
  right: 10px;
  display: block;
  height: 20px;
  width: 20px;
}

.checkmark.select,
.loader.select {
  right: 30px;
  z-index: 1000;
}

.clickable-row {
  cursor: pointer;
}

.indent-row {
  margin-left: 15px;
}
</style>
